import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const customBlankSpacesValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	//const value = control.value as string;
	const value = control.value != null ? String(control.value) : '';
	
	//if (control.value && control.value.trim() === '') {
	if (value && value.trim() === '') {
		return  { customBlankSpacesValidator: true };
	  }

	return null;
};

export const confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const password = control.get('claveNueva');
	const confirmPassword = control.get('repetirClaveNueva');
	
	if (password && confirmPassword) {
		// Solo valida si ambos campos tienen valor
		return password.value && confirmPassword.value && password.value !== confirmPassword.value
			? { PasswordNoMatch: true }
			: null;
	}
	
	return null; // Devuelve null si no se puede validar
};
